import { useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import * as axios from 'axios'
import { useSnackbar } from 'notistack'
import JwtDecode from 'jwt-decode'

const AutoLogin = () => {
    const location = useLocation()
    const history = useHistory()
    const { enqueueSnackbar } = useSnackbar()
    const emailId = location.pathname.split('/').pop()
    console.log('Login', emailId)
    useEffect(() => {
        const autoLoginUser = () => {
            const body = {
                username: emailId,
                password: '12345678',
                autologin: 1,
                encrypt: 0,
            }
            const headers = {
                site_id: process.env.REACT_APP_SITE_ID,
            }

            axios
                .post(`${process.env.REACT_APP_MOBILE_API_URL}/login`, body, { headers: headers })
                .then((resp) => {
                    if (resp?.data?.status == 'yes') {
                        localStorage.setItem('coachToken', resp.data.data)
                        localStorage.setItem('coachUser', JSON.stringify(JwtDecode(resp.data.data)))
                        localStorage.setItem('autoLogin', 1)
                        const decode = JwtDecode(resp.data.data)

                        if (decode.role == 4) {
                            enqueueSnackbar('Switch user sucessfull!', { variant: 'success' })
                            return history.push('/dashboard/ambassador/mylots', location.state)
                        } else {
                            localStorage.removeItem('coachToken')
                            localStorage.removeItem('coachUser')
                            localStorage.removeItem('autoLogin')
                            return history.push('/', location.state)
                        }
                    } else {
                        enqueueSnackbar('Failed to switch user.', { variant: 'failed' })
                    }
                })
                .catch((error) => {
                    console.error('Error - Auto Login', error)
                    enqueueSnackbar('Failed to switch user.', { variant: 'failed' })
                })
        }

        autoLoginUser()
    }, [emailId])

    return null
}

export default AutoLogin
